import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import PropTypes from 'prop-types';
import { Spacings } from '@styles/index';

const keyFrameOpen = keyframes`
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;

const TimerIcon = styled.div`
  display: flex;
  width: 48px;
  height: 48px;
  border-radius: ${Spacings.SPACING_6B};
  align-items: center;
  justify-content: center;
  background-color: ${({ $bgColor }) => $bgColor};
`;

const OuterCircle = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 13px;
  border: 2px solid var(--color-i-white);
  justify-content: center;
  display: flex;
  padding: 2px;
  position: relative;
`;

const HourHand = styled.div`
  height: 10px;
  width: 2px;
  border-radius: 1px;
  background-color: var(--color-base-1);
  position: absolute;
`;

const MinuteWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  animation-name: ${keyFrameOpen};
  animation-duration: 5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
`;

const MinuteHand = styled.div`
  height: 10px;
  width: 2px;
  border-radius: 1px;
  background-color: var(--color-base-1);
`;

const Holder = styled.div`
  height: 4px;
  width: 4px;
  border-radius: 2px;
  background-color: white;
  align-self: center;
  position: absolute;
`;

const ClockLoader = ({ color }) => (
  <TimerIcon $bgColor={color}>
    <OuterCircle>
      <HourHand />
      <Holder />
      <MinuteWrapper>
        <MinuteHand />
      </MinuteWrapper>
    </OuterCircle>
  </TimerIcon>
);

ClockLoader.propTypes = {
  color: PropTypes.string
};

ClockLoader.defaultProps = {
  color: 'var(--color-i-orange-1)'
};

export default ClockLoader;
